import React, { useState, useEffect } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import { ReactComponent as FilePlusFill } from "bootstrap-icons/icons/file-plus-fill.svg";
import { ReactComponent as DashSquareFill } from "bootstrap-icons/icons/dash-square-fill.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ApiServices from "../../../api/ApiServices";
import AxiosApiCall from "../../../api/AxiosApiCall";
import Spinner from "../../spinner/Spinner";
import { handleError } from "../../../components/utils/AuthenticationCheck";

const AddBranchProduct = () => {
  const [branches, setBranches] = useState([]);
  const [productUnits, setProductUnits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [isPricingRequired, setIsPricingRequired] = useState(false); //use this to optional send empty value for quantity pricing if is not available

  // Form state
  const [formData, setFormData] = useState({
    branch_id: "",
    branch_product_unit_id: "",
    base_price: "",
    unit: "",
    description: "",
    quantity_pricing: []
  });

  const navigate = useNavigate();
  const axios = AxiosApiCall();

  // Fetch branches
  const fetchBranches = async () => {
    setLoading(true);
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) throw new Error("No access token found");

      const response = await axios.get(ApiServices.getAllBranchOperations, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      const { status, data } = response.data;
      // console.log("Branches API Response:", response.data);
      if (status === 200) {
        setBranches(data);
      } else {
        handleError({ response }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  // Fetch product units
  const fetchProductUnits = async () => {
    setLoading(true);
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) {
        throw new Error("No access token found.");
      }

      const response = await axios.post(
        ApiServices.getAllBranchProductUnit,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      //  console.log("Full API Response from product unit:", response.data);

      const responseData = response.data;
      const status = responseData?.status;
      const message = responseData?.message;
      const resData = responseData?.data || {};

      if (status === "200" || status === 200) {
        // Get the products array from the paginated response
        const productsData = Array.isArray(resData.data) ? resData.data : [];

        // Parse the JSON strings in the response
        // const parsedProducts = productsData.map(product => ({
        //   ...product,
        //   quantity_pricing: product.quantity_pricing ? JSON.parse(product.quantity_pricing) : null,
        //   specifications: product.specifications ? JSON.parse(product.specifications) : null
        // }));

        const parsedProducts = productsData.map(product => ({
          ...product,
          quantity_pricing: Array.isArray(product.quantity_pricing) ? product.quantity_pricing : [],
          specifications: Array.isArray(product.specifications) ? product.specifications : []
        }));

        setProductUnits(parsedProducts);
        // toast.success(message, { toastId: "branch-product-unit-fetch-success" });
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };


  const handleProductUnitChange = (e) => {
    const unitId = e.target.value;
    const selectedUnit = productUnits.find(unit => unit.id == unitId);

    if (selectedUnit) {
      setFormData({
        ...formData,
        branch_product_unit_id: unitId,
        base_price: selectedUnit.base_price,
        unit: selectedUnit.unit,
        description: selectedUnit.description || "",
        quantity_pricing: selectedUnit.quantity_pricing || [] // Use the already parsed pricing
      });
      // Set pricing required based on some logic
      setIsPricingRequired(selectedUnit.quantity_pricing.length > 0);
    } else {
      // Reset form if no product selected
      setFormData({
        ...formData,
        branch_product_unit_id: "",
        base_price: "",
        unit: "",
        description: "",
        quantity_pricing: []
      });
    }
  };

  // const handleProductUnitChange = (e) => {
  //   const unitId = e.target.value;
  //   const selectedUnit = productUnits.find(unit => unit.id == unitId);

  //   if (selectedUnit) {
  //     // Parse the quantity_pricing if it exists
  //     let parsedPricing = [];
  //     try {
  //       parsedPricing = selectedUnit.quantity_pricing
  //         ? JSON.parse(selectedUnit.quantity_pricing)
  //         : [];
  //     } catch (error) {
  //       console.error("Error parsing quantity pricing:", error);
  //       parsedPricing = [];
  //     }

  //     setFormData({
  //       ...formData,
  //       branch_product_unit_id: unitId,
  //       base_price: selectedUnit.base_price,
  //       unit: selectedUnit.unit,
  //       description: selectedUnit.description || "",
  //       quantity_pricing: parsedPricing
  //     });
  //   } else {
  //     // Reset form if no product selected
  //     setFormData({
  //       ...formData,
  //       branch_product_unit_id: "",
  //       base_price: "",
  //       unit: "",
  //       description: "",
  //       quantity_pricing: []
  //     });
  //   }
  // };

  // Handle form field changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle quantity pricing changes
  const handlePricingChange = (index, field, value) => {
    const updatedPricing = [...formData.quantity_pricing];
    updatedPricing[index][field] = value === "" ? null : value;
    setFormData({ ...formData, quantity_pricing: updatedPricing });
  };

  // Add new pricing tier
  const addPricingTier = () => {
    setFormData({
      ...formData,
      quantity_pricing: [
        ...formData.quantity_pricing,
        { min_quantity: "", max_quantity: "", price: "" }
      ]
    });
  };

  // Remove pricing tier
  const removePricingTier = (index) => {
    const updatedPricing = formData.quantity_pricing.filter((_, i) => i !== index);
    setFormData({ ...formData, quantity_pricing: updatedPricing });
  };



  // Form validation
  const validateForm = () => {
    if (!formData.branch_id || !formData.branch_product_unit_id || !formData.base_price || !formData.unit) {
      toast.error("Please fill all required fields");
      return false;
    }

    // Validate pricing tiers
    // for (const tier of formData.quantity_pricing) {
    //   if (!tier.min_quantity || !tier.price) {
    //     toast.error("Please fill all required fields in quantity pricing");
    //     return false;
    //   }
    // }

    return true;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    if (isPricingRequired && !formData.quantity_pricing.length) {
      setFormData({
        ...formData,
        quantity_pricing: [{ min_quantity: "", max_quantity: "", price: "" }]  // Default empty tier
      });
    }

    setFormLoading(true);
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) throw new Error("No access token found");

      // Prepare the payload

      const payload = {
        ...formData,
        quantity_pricing: isPricingRequired
          ? formData.quantity_pricing.map(tier => ({
            ...tier,
            min_quantity: parseInt(tier.min_quantity),
            max_quantity: tier.max_quantity ? parseInt(tier.max_quantity) : 0,
            price: parseFloat(tier.price)
          }))
          : [
            {
              min_quantity: 0,
              max_quantity: 0,
              price: 0.00,
            },
          ],
      };


      // console.log("Submitting payload:", payload);

      const response = await axios.post(
        ApiServices.createBranchProduct,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      const { status, message } = response.data;
      // console.log("API Response:", response.data);
      if (status === "200" || status === 201) {
        toast.success(message);
        navigate("/operations/branch/products");
      } else {
        handleError({ response }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setFormLoading(false);
    }
  };

  useEffect(() => {
    fetchBranches();
    fetchProductUnits();
  }, []);

  return (
    <MainLayouts>
      <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
        <section className="body-font">
          <div className="container px-5 pb-2 mx-auto">
            {/* Breadcrumb Navigation */}
            <section
              className="w-full pr-[3%] pt-3 my-3"
              style={{ backgroundColor: "#F7F7F7" }}
            >
              {/* Flex container for breadcrumb and back button */}
              <div className="flex justify-between items-center bg-gray-200 py-2 px-4 rounded-lg mb-3">
                {/* Breadcrumb - Left aligned */}
                <nav>
                  <ol className="list-none p-0 inline-flex">
                    <li className="flex items-center">
                      <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                        Branch Operation
                      </p>
                      <ChevronRightIcon />
                    </li>
                    <li className="flex items-center">
                      <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                        Branch Product
                      </p>
                      <ChevronRightIcon />
                    </li>
                    <li className="flex items-center">
                      <p className="text-orange1">Create</p>
                    </li>
                  </ol>
                </nav>
              </div>
            </section>

            {/* Main Form */}
            <div className="lg:w-full md:w-full bg-white rounded-lg p-8 flex flex-col w-full mt-10 md:mt-0 relative z-10 shadow-md">
              <form onSubmit={handleSubmit} className=" px-4 py-4 rounded-sm" style={{ backgroundColor: "#F7F7F7" }}>
                {/* Row 1: Branch and Product Unit */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  {/* Branch Selection */}
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-900">
                      Branch *
                    </label>
                    <select
                      name="branch_id"
                      value={formData.branch_id}
                      onChange={handleInputChange}
                      className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      required
                      disabled={loading}
                    >
                      <option value="">Select Branch</option>
                      {branches.map(branch => (
                        <option key={branch.id} value={branch.id}>
                          {branch.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Product Unit Selection */}
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-900">
                      Product Unit *
                    </label>
                    <select
                      name="branch_product_unit_id"
                      value={formData.branch_product_unit_id}
                      onChange={handleProductUnitChange}
                      className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      required
                      disabled={loading}
                    >
                      <option value="">Select Product Unit</option>
                      {productUnits.map(unit => (
                        <option key={unit.id} value={unit.id}>
                          {unit.product_units_name} ({unit.unit})
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Row 2: Base Price and Unit */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  {/* Base Price */}
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-900">
                      Base Price *
                    </label>
                    <input
                      type="number"
                      name="base_price"
                      value={formData.base_price}
                      onChange={handleInputChange}
                      className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      placeholder="Enter base price"
                      required
                      step="0.01"
                      min="0"
                    />
                  </div>

                  {/* Unit */}
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-900">
                      Unit *
                    </label>
                    <input
                      type="text"
                      name="unit"
                      value={formData.unit}
                      onChange={handleInputChange}
                      className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      placeholder="Enter unit (e.g., piece, kg)"
                      required
                    />
                  </div>
                </div>

                {/* Row 3: Description (full width) */}
                <div className="mb-6">
                  <label className="block mb-2 text-sm font-medium text-gray-900">
                    Description
                  </label>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                    placeholder="Enter product description"
                    rows="3"
                  />
                </div>

                {/* Quantity Pricing Section */}
                {/* Quantity Pricing Section */}
                <div className="mb-6">
                  <div className="flex justify-between items-center mb-2">
                    <label className="block text-sm font-medium text-gray-900">
                      Quantity Pricing
                    </label>
                    <button
                      type="button"
                      onClick={addPricingTier}
                      className="text-sm bg-darkGreen3 text-lGrey hover:text-lGrey py-1 px-1 flex items-center"
                    >
                      <FilePlusFill className="w-4 h-4 mr-1" />
                      Add Tier
                    </button>
                  </div>

                  {formData.quantity_pricing.length > 0 && (
                    <div className="mb-2 grid grid-cols-12 gap-2 font-medium text-sm text-gray-700">
                      <div className="col-span-4">Min Quantity</div>
                      <div className="col-span-4">Max Quantity</div>
                      <div className="col-span-3">Price</div>
                      <div className="col-span-1">Action</div>
                    </div>
                  )}

                  {formData.quantity_pricing.length === 0 ? (
                    <div className="text-center py-4 text-gray-500">
                      {formData.branch_product_unit_id
                        ? "No pricing tiers available for this product"
                        : "Select a product unit to see pricing tiers"}
                    </div>
                  ) : (
                    <div className="space-y-3">
                      {formData.quantity_pricing.map((tier, index) => (
                        <div key={index} className="grid grid-cols-12 gap-2 items-center">
                          <div className="col-span-4">
                            <input
                              type="number"
                              value={tier.min_quantity || ""}
                              onChange={(e) => handlePricingChange(index, 'min_quantity', e.target.value)}
                              className="bg-gray-50 border border-lGrey text-black1 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                              placeholder="Min Qty"
                              min="0"
                              required
                            />
                          </div>
                          <div className="col-span-4">
                            <input
                              type="number"
                              value={tier.max_quantity || ""}
                              onChange={(e) => handlePricingChange(index, 'max_quantity', e.target.value)}
                              className="bg-gray-50 border border-lGrey text-black1 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                              placeholder="Max Qty (optional)"
                              min={tier.min_quantity || 0}
                            />
                          </div>
                          <div className="col-span-3">
                            <input
                              type="number"
                              value={tier.price || ""}
                              onChange={(e) => handlePricingChange(index, 'price', e.target.value)}
                              className="bg-gray-50 border border-lGrey text-black1 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                              placeholder="Price"
                              step="0.01"
                              min="0"
                              required
                            />
                          </div>
                          <div className="col-span-1">
                            <button
                              type="button"
                              onClick={() => removePricingTier(index)}
                              className="text-dash3 hover:text-dash3"
                            >
                              <DashSquareFill className="w-5 h-5" />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Form Actions */}
                <div className="flex flex-col gap-4 md:flex-row md:gap-4 md:justify-end mt-6">
                  <Link
                    to="/operations/branch/products"
                    className="flex items-center justify-center  text-dGrey3 bg-black2 py-4 px-6 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm  text-center"
                  >
                    <List className="mr-2" />
                    Back To List
                  </Link>
                  <button
                    type="submit"
                    className={`text-lGrey flex items-center justify-center text-white bg-darkGreen3 hover:bg-darkGreen4 py-2 px-6 rounded-lg text-sm font-medium transition-colors ${formLoading ? "opacity-75 cursor-not-allowed" : ""
                      }`}
                    disabled={formLoading}
                  >
                    {formLoading ? (
                      <>
                        <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Processing...
                      </>
                    ) : (
                      "Create Branch Product"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </MainLayouts>
  );
};

export default AddBranchProduct;